import { baseurlv2HttpRequest } from '../../../../service';
export const triggerOtp = (triggerOTPRequestBodyBody, signal) => {
    return baseurlv2HttpRequest({
        url: `/customers/trigger-otp`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: triggerOTPRequestBodyBody,
        signal
    });
};
//# sourceMappingURL=triggerOtp.js.map